/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// custom function import
import { maintainLogCheckListData } from '../../store/Actions';
import {
  checkIfAmountNum,
  replaceCommaIntoWhiteSpace,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import NumberFormatCustom from '../../../../../SharedModules/NumberFormat/NumberFormat';

export default (props) => {
  const [isTooltip, setIsTooltip] = React.useState(false);
  const dispatch = useDispatch();
  const addNewRowLogCheckList = (data, action) => {
    return dispatch(maintainLogCheckListData(data, action));
  };
  const logCheckRowData = useSelector((state) => {
    return state.sharedState.CheckLogReducer.logCheckList;
  });
  const { colId } = props.column;
  let rowIndex = 0;
  if (logCheckRowData && logCheckRowData.length > 0) {
    rowIndex = logCheckRowData.findIndex((x) => {
      return x.checkLogNum === props.data.checkLogNum;
    });
  }
  const checkLength = (e) => {
    if (e?.target?.value?.length > 34) {
      setIsTooltip(true);
    } else {
      setIsTooltip(false);
    }
  };
  // call onBlur event and check validation
  const handleChange = (e) => {
    const newObj = [...logCheckRowData];
    newObj[rowIndex].rowWithNewChange = true;
    if (colId === 'checkIssuer') {
      if (e.target.value == '' || e.target.value === null) {
        props.node.setDataValue(colId, e.target.value);
        newObj[rowIndex][props.column.colId] = e.target.value;
        newObj[rowIndex].checkIssuerErr = true;
        newObj[rowIndex].isYes = false;
        addNewRowLogCheckList(newObj, 'verify');
      } else {
        props.node.setDataValue(colId, e.target.value);
        newObj[rowIndex][props.column.colId] = e.target.value;
        newObj[rowIndex].checkIssuerErr = false;
        newObj[rowIndex].isYes = false;
        addNewRowLogCheckList(newObj, 'verify');
      }
      newObj[rowIndex].checkPayeeCDActiveCursor = false;
      newObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
      newObj[rowIndex].disputeResolutionCDActiveCursor = false;
      addNewRowLogCheckList(newObj, 'verify');
      props.handleOnblurEventCheckIssue();
    } else if (colId === 'checkAmt') {
      newObj[rowIndex].checkPayeeCDActiveCursor = false;
      newObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
      newObj[rowIndex].disputeResolutionCDActiveCursor = false;
      if (e.target.value == '' || e.target.value === null) {
        props.node.setDataValue(colId, e.target.value);
        newObj[rowIndex][props.column.colId] = e.target.value;
        newObj[rowIndex].checkAmtErr = true;
        newObj[rowIndex].checkAmtActiveCursor = false;
        newObj[rowIndex].isYes = false;
        addNewRowLogCheckList(newObj, 'verify');
      } else if (
        e.target.value !== '' &&
        (Number.isNaN(parseFloat(e.target.value)) ||
          checkIfAmountNum(e.target.value) === false)
      ) {
        props.node.setDataValue(colId, e.target.value);
        newObj[rowIndex][props.column.colId] = e.target.value;
        newObj[rowIndex].checkAmtErr = true;
        newObj[rowIndex].checkAmtActiveCursor = false;
        newObj[rowIndex].isYes = false;
        addNewRowLogCheckList(newObj, 'verify');
      } else if (parseFloat(e.target.value) === 0) {
        props.node.setDataValue(colId, e.target.value);
        newObj[rowIndex][props.column.colId] = e.target.value;
        newObj[rowIndex].checkAmtErr = true;
        newObj[rowIndex].checkAmtActiveCursor = false;
        newObj[rowIndex].isYes = false;
        addNewRowLogCheckList(newObj, 'verify');
      } else {
        props.node.setDataValue(colId, e.target.value);
        newObj[rowIndex][props.column.colId] = e.target.value;
        newObj[rowIndex].checkAmtErr = false;
        newObj[rowIndex].checkAmtActiveCursor = false;
        newObj[rowIndex].isYes = false;
        addNewRowLogCheckList(newObj, 'verify');
      }
      props.handleOnblurEventCheckAmt();
    } else {
      if (colId === 'checkNum') {
        newObj[rowIndex].batchNumErr = false;
        addNewRowLogCheckList(newObj, 'verify');
      }
      newObj[rowIndex].checkPayeeCDActiveCursor = false;
      newObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
      newObj[rowIndex].disputeResolutionCDActiveCursor = false;
      addNewRowLogCheckList(newObj, 'verify');
      props.node.setDataValue(colId, e.target.value);
    }
  };
  if (colId === 'checkIssuer') {
    return (
      <div data-testid="log-check-text-box">
        {isTooltip ? (
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="add-tooltip">{props.value}</Tooltip>}
          >
            <TextField
              autoComplete="off"
              id={`${colId}_${rowIndex}`}
              label={colId}
              data-testid="check-issuer "
              className={
                logCheckRowData &&
                logCheckRowData[rowIndex] &&
                logCheckRowData[rowIndex].checkIssuerErr !== undefined &&
                logCheckRowData[rowIndex].checkIssuerErr
                  ? 'td-active-cell tBill-validate frr-display-hidden-label'
                  : 'frr-display-hidden-label'
              }
              fullWidth
              placeholder=""
              InputLabelProps={{ shrink: true }}
              inputProps={{
                maxLength: 255,
                id: `${colId}_${rowIndex}`,
              }}
              value={props.value}
              onChange={handleChange}
              onBlur={(e) => {
                handleChange(e);
                checkLength(e);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Tab' && !e.shiftKey) {
                  const tempObj = [...logCheckRowData];
                  tempObj[rowIndex].checkPayeeCDActiveCursor = false;
                  tempObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
                  tempObj[rowIndex].disputeResolutionCDActiveCursor = false;
                  addNewRowLogCheckList(tempObj, 'verify');
                  if (colId === 'checkIssuer') {
                    const nextElement = document.getElementById(
                      `checkInfo_${rowIndex}`
                    );
                    if (nextElement) {
                      nextElement.focus();
                      e.preventDefault();
                    }
                  }
                }
              }}
            />
          </OverlayTrigger>
        ) : (
          <TextField
            autoComplete="off"
            id={`${colId}_${rowIndex}`}
            label={colId}
            className={
              logCheckRowData &&
              logCheckRowData[rowIndex] &&
              logCheckRowData[rowIndex].checkIssuerErr !== undefined &&
              logCheckRowData[rowIndex].checkIssuerErr
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
            }
            data-testid="check-issuer"
            fullWidth
            placeholder=""
            InputLabelProps={{ shrink: true }}
            inputProps={{
              maxLength: 255,
              id: `${colId}_${rowIndex}`,
            }}
            value={props.value}
            onChange={handleChange}
            onBlur={(e) => {
              handleChange(e);
              checkLength(e);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Tab' && !e.shiftKey) {
                const tempObj = [...logCheckRowData];
                tempObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
                tempObj[rowIndex].disputeResolutionCDActiveCursor = false;
                tempObj[rowIndex].checkPayeeCDActiveCursor = false;
                addNewRowLogCheckList(tempObj, 'verify');
                if (colId === 'checkIssuer') {
                  const nextElement = document.getElementById(
                    `checkInfo_${rowIndex}`
                  );
                  if (nextElement) {
                    nextElement.focus();
                    e.preventDefault();
                  }
                }
              }
            }}
          />
        )}
      </div>
    );
  }
  return (
    <div data-testid="log-check-text-box">
      {colId === 'checkAmt' ? (
        <TextField
          autoComplete="off"
          data-testid="check-amt"
          id={`${colId}_${rowIndex}`}
          label={colId}
          autoFocus={props.data && props.data.checkAmtActiveCursor}
          className={
            logCheckRowData &&
            logCheckRowData[rowIndex] &&
            logCheckRowData[rowIndex].checkAmtErr !== undefined &&
            logCheckRowData[rowIndex].checkAmtErr
              ? 'frr-input_amount_log frr-display-hidden-label td-active-cell tBill-validate'
              : 'frr-input_amount_log frr-display-hidden-label'
          }
          fullWidth
          placeholder=""
          InputLabelProps={{
            shrink: true,
          }}
          // original length only 15 digit but some comma separated code so add extra 5 spaces
          inputProps={{
            maxLength: 20,
            id: `${colId}_${rowIndex}`,
          }}
          InputProps={{
            inputComponent: NumberFormatCustom,
          }}
          value={replaceCommaIntoWhiteSpace(props.value)}
          onChange={(e) => {
            if (e.target.value && e.target.value.includes('.')) {
              const rx = /^-?[0-9]\d{0,12}(\.\d{1,2})?$/;
              if (rx.test(e.target.value)) {
                handleChange(e);
              }
            } else {
              const rx_without = /^[A-Za-z0-9]{0,13}?$/;
              if (rx_without.test(e.target.value)) {
                handleChange(e);
              }
            }
          }}
          onBlur={(e) => {
            handleChange(e);
          }}
          onFocus={(e) => {
            if (parseFloat(e.target.value) <= 0) {
              props.node.setDataValue('checkAmt', '');
              const tempObj = [...logCheckRowData];
              tempObj[rowIndex].checkAmt = '';
            }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Tab' && !e.shiftKey) {
              const tempObj = [...logCheckRowData];
              tempObj[rowIndex].checkPayeeCDActiveCursor = true;
              tempObj[rowIndex].checkAmtActiveCursor = false;
              tempObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
              tempObj[rowIndex].disputeResolutionCDActiveCursor = false;
              addNewRowLogCheckList(tempObj, 'verify');
            }
          }}
        />
      ) : props?.value?.length > 15 ? (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="add-tooltip">{props.value}</Tooltip>}
        >
          <TextField
            autoComplete="off"
            id={`${colId}_${rowIndex}`}
            label={colId}
            data-testid={
              colId === 'checkNum'
                ? 'check-num'
                : colId === 'batchNum'
                ? 'batch-num'
                : ''
            }
            className={
              colId === 'batchNum'
                ? logCheckRowData &&
                  logCheckRowData[rowIndex] &&
                  logCheckRowData[rowIndex].batchNumErr !== undefined &&
                  logCheckRowData[rowIndex].batchNumErr
                  ? 'td-active-cell tBill-validate frr-display-hidden-label'
                  : 'frr-display-hidden-label'
                : 'frr-display-hidden-label'
            }
            fullWidth
            placeholder=""
            InputLabelProps={{ shrink: true }}
            inputProps={{
              maxLength:
                props.column.colId == 'batchNum'
                  ? 50
                  : props.column.colId == 'checkIndentifier'
                  ? 40
                  : props.column.colId == 'checkNum'
                  ? 20
                  : props.column.colId == 'checkInfo'
                  ? 2000
                  : 50,
              id: `${colId}_${rowIndex}`,
            }}
            value={props.value}
            onChange={handleChange}
            onBlur={handleChange}
            onKeyDown={(e) => {
              if (e.key === 'Tab' && !e.shiftKey) {
                const tempObj = [...logCheckRowData];
                tempObj[rowIndex].checkPayeeCDActiveCursor = false;
                tempObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
                tempObj[rowIndex].disputeResolutionCDActiveCursor = false;
                addNewRowLogCheckList(tempObj, 'verify');
                if (colId === 'checkInfo') {
                  const nextElement = document.getElementById(
                    `checkDt_${rowIndex}`
                  );
                  if (nextElement) {
                    nextElement.focus();
                    e.preventDefault();
                  }
                }
              }
            }}
          />
        </OverlayTrigger>
      ) : (
        <TextField
          autoComplete="off"
          id={`${colId}_${rowIndex}`}
          label={colId}
          className={
            colId === 'batchNum'
              ? logCheckRowData &&
                logCheckRowData[rowIndex] &&
                logCheckRowData[rowIndex].batchNumErr !== undefined &&
                logCheckRowData[rowIndex].batchNumErr
                ? 'td-active-cell tBill-validate frr-display-hidden-label'
                : 'frr-display-hidden-label'
              : 'frr-display-hidden-label'
          }
          data-testid={
            colId === 'checkNum'
              ? 'check-num'
              : colId === 'batchNum'
              ? 'batch-num'
              : ''
          }
          autoFocus={
            colId === 'batchNum' &&
            logCheckRowData[rowIndex]?.batchNumActiveCursor
          }
          fullWidth
          placeholder=""
          InputLabelProps={{ shrink: true }}
          inputProps={{
            maxLength:
              props.column.colId == 'batchNum'
                ? 50
                : props.column.colId == 'checkIdentifier'
                ? 40
                : props.column.colId == 'checkNum'
                ? 20
                : props.column.colId == 'checkInfo'
                ? 2000
                : 50,
            id: `${colId}_${rowIndex}`,
          }}
          value={props.value}
          onChange={handleChange}
          onBlur={handleChange}
          onKeyDown={(e) => {
              if (e.key === 'Tab' && !e.shiftKey) {
                const tempObj = [...logCheckRowData];
                tempObj[rowIndex].paymentMediaTypeCDActiveCursor = false;
                tempObj[rowIndex].disputeResolutionCDActiveCursor = false;
                tempObj[rowIndex].checkPayeeCDActiveCursor = false;
                addNewRowLogCheckList(tempObj, 'verify');
                if (colId === 'checkInfo') {
                  const nextElement = document.getElementById(
                    `checkDt_${rowIndex}`
                  );
                  if (nextElement) {
                    nextElement.focus();
                    e.preventDefault();
                  }
                }
              }
            }}
        />
      )}
    </div>
  );
};
